import DOMPurify from "dompurify";

type DomPurifyLike = {
	sanitize?: (value: string, config?: unknown) => string;
};

/**
 * Sanitizes HTML before it is used with dangerouslySetInnerHTML.
 *
 * Fails CLOSED: if DOMPurify cannot run (the SSR bundle has no DOM, so the import is only a
 * factory without `.sanitize`) or throws, return an empty string instead of the raw HTML.
 * Nothing is lost on the server: the admin client uses ReactDOM.render (not hydrate), so the
 * browser re-renders the content with the real sanitizer.
 */
export default function sanitizeHtml(value: string, config?: unknown) {
	if (!value) {
		return "";
	}

	const purifier = DOMPurify as unknown as DomPurifyLike;

	if (typeof purifier.sanitize !== "function") {
		return "";
	}

	try {
		return purifier.sanitize(value, config);
	} catch (error) {
		return "";
	}
}
